import { LUSTRATION_TABS } from '../../common/cuzkMonitorTypes'
import { PROPERTY_TYPES } from '../../common/drmTypes'
import { PROPERTY_TABS } from '../../common/propertyDetailTypes'
import {
  auctionDropdown,
  BreadcrumbConfig,
  ceeDropdown,
  foreclosureDropdown,
  insolvencyDropdown,
  monitoringDropdown,
  overviewDropdown,
  propertyDropdown,
  searchDropdown,
  watchdogDropdown,
  wsdpDropdown,
} from './breadcrumbHelpers'
import {
  addressPath,
  areaPath,
  auctionMonitoringPath,
  buybackPath,
  cadastreMapPath,
  ceeCheckCreatePath,
  ceeCheckPath,
  ceeMonitorCreatePath,
  ceeMonitorPath,
  ceePath,
  cuzkDocumentCollectionPath,
  cuzkEpoDetailPath,
  cuzkEpoPath,
  cuzkLvDetailPath,
  cuzkLvPath,
  cuzkMonitorRcCreatePath,
  cuzkMonitorRcPath,
  cuzkWsdpPath,
  dataBoxDetailPath,
  dataBoxPath,
  foreclosureMonitoringPath,
  heritageMonitoringPath,
  homePath,
  insolvencyMonitoringPath,
  labelDetailPath,
  labelPath,
  lvDetailPath,
  lvPath,
  marketplacePath,
  monitoringPath,
  overwievPath,
  postServiceCreatePath,
  postServiceLetterPath,
  postServicePath,
  postServiceRecipientListPath,
  postServiceSentListPath,
  postServiceSentPath,
  postServiceTemplatesPath,
  priceEstimatePath,
  proceedingDetailPath,
  proceedingPath,
  propertyDetailPath,
  propertyListDetailPath,
  propertyListPath,
  propertyNotePath,
  propertyPath,
  searchPath,
  statisticsPath,
  subjectDetailPath,
  subjectPath,
  watchdogChannelPath,
  watchdogPath,
  watchdogPropertyPath,
} from './paths'
import {
  COLLECTION_TABS,
  LABEL_TABS,
  MONITORING_TABS,
  monitoringTabSlug,
  SUBJECT_TABS,
} from './tabsHelpers'

const property: BreadcrumbConfig = {
  path: propertyPath(),
  name: 'Nemovitosti',
  title: 'Nemovitosti',
  menu: propertyDropdown,
  children: [
    {
      path: propertyDetailPath(':propertyType' as PROPERTY_TYPES),
      name: 'Typ nemovitosti',
      title: 'Typ nemovitosti',
      disabled: true,
      dynamicLabels: {
        propertyType: (type: string) =>
          monitoringTabSlug[type as PROPERTY_TYPES] || type,
      },
      children: [
        {
          path: propertyDetailPath(':propertyType' as PROPERTY_TYPES),
          name: 'Detail',
          title: 'Detail nemovitosti',
          disabled: true,
          tabLabels: PROPERTY_TABS,
          children: [
            {
              path: propertyDetailPath(
                ':propertyType' as PROPERTY_TYPES,
                ':id'
              ),
              name: 'Tab',
              title: 'Detail nemovitosti',
              tabLabels: PROPERTY_TABS,
            },
          ],
        },
      ],
    },
  ],
}

const dashboard: BreadcrumbConfig = {
  path: homePath(),
  name: 'Nástěnka',
  title: 'Nástěnka',
  children: [
    {
      path: homePath(),
      name: 'Přehled změn',
      title: 'Nástěnka',
    },
  ],
}

const overview: BreadcrumbConfig = {
  path: overwievPath(),
  name: 'Přehledy',
  title: 'Přehledy',
  menu: overviewDropdown,
  children: [
    {
      path: '/prehledy/vyvoj-aplikace',
      name: 'Vývoj aplikace',
      title: 'Přehled vývoje aplikace',
    },
    {
      path: propertyNotePath(),
      name: 'Poznámky',
      title: 'Poznámky k nemovitostem',
    },
    {
      path: labelPath(),
      name: 'Štítky',
      title: 'Štítky',
      children: [
        {
          path: labelDetailPath(),
          name: 'Detail štítku',
          title: 'Detail štítku',
          disabled: true,
          tabLabels: LABEL_TABS,
        },
      ],
    },
  ],
}

const search: BreadcrumbConfig = {
  path: searchPath(),
  name: 'Vyhledávání',
  title: 'Vyhledávání',
  menu: searchDropdown,
  children: [
    {
      path: addressPath(),
      name: 'Adresa',
      title: 'Vyhledávání - Adresa',
    },

    {
      path: areaPath(),
      name: 'Parcela',
      title: 'Vyhledávání - Parcela',
    },
    {
      path: lvPath(),
      name: 'List vlastnictví',
      title: 'Vyhledávání - List vlastnictví',
      children: [
        {
          path: lvDetailPath(':katuze', ''),
          name: 'Katastrální území',
          title: 'Detail listu vlastnictví',
          dynamicLabels: {
            katuze: (katuze: string) => katuze,
          },
          children: [
            {
              path: lvDetailPath(':katuze', ':lv'),
              name: 'Číslo LV',
              title: 'Detail listu vlastnictví',
              dynamicLabels: {
                lv: (lv: string) => lv,
              },
            },
          ],
        },
      ],
    },
    {
      path: proceedingPath(),
      name: 'Řízení',
      title: 'Vyhledávání - Řízení',
      children: [
        {
          path: proceedingDetailPath(':urlQuery'),
          name: 'Detail',
          title: 'Detail řízení',
        },
      ],
    },
    {
      path: subjectPath(),
      name: 'Subjekt',
      title: 'Vyhledávání - Subjekt',
      children: [
        {
          path: subjectDetailPath(':id'),
          name: 'Detail',
          title: 'Detail subjektu',
          tabLabels: SUBJECT_TABS,
        },
      ],
    },
    {
      path: dataBoxPath(),
      name: 'Datová schránka',
      title: 'Vyhledávání - Datová schránka',
      children: [
        {
          path: dataBoxDetailPath(':urlQuery'),
          name: 'Detail',
          title: 'Datová schránka',
        },
      ],
    },
  ],
}

const cadastreMap: BreadcrumbConfig = {
  path: cadastreMapPath(),
  name: 'Katastrální mapa',
  title: 'Katastrální mapa',
}

const buyback: BreadcrumbConfig = {
  path: buybackPath(),
  name: 'Kalkulace nabídek',
  title: 'Kalkulace nabídek',
}

const propertyList: BreadcrumbConfig = {
  path: propertyListPath(),
  name: 'Seznam nemovitostí',
  title: 'Seznam nemovitostí',
  children: [
    {
      path: propertyListDetailPath(),
      name: 'Detail seznamu',
      title: 'Detail seznamu nemovitostí',
    },
  ],
}

const cee: BreadcrumbConfig = {
  path: ceePath(),
  name: 'CEE',
  title: 'CEE',
  menu: ceeDropdown,
  children: [
    {
      path: ceeCheckPath(),
      name: 'Vyhledávání',
      title: 'Vyhledávání subjektů v CEE',
      children: [
        {
          path: ceeCheckCreatePath(),
          name: 'Vyhledat nový',
          title: 'Vyhledat subjekty v CEE',
          tabLabels: LUSTRATION_TABS,
        },
      ],
    },
    {
      path: ceeMonitorPath(),
      name: 'Hlídání subjektů',
      title: 'CEE',
      children: [
        {
          path: ceeMonitorCreatePath(),
          name: 'Přidat nový',
          title: 'Přidat subjekt do hlídače CEE',
          tabLabels: LUSTRATION_TABS,
        },
      ],
    },
  ],
}

const priceEstimate: BreadcrumbConfig = {
  path: priceEstimatePath(),
  name: 'Cenové odhady',
  title: 'Cenové odhady',
}

const marketplace: BreadcrumbConfig = {
  path: marketplacePath(),
  name: 'Marketplace',
  title: 'bid&click Marketplace',
}

const postService: BreadcrumbConfig = {
  path: postServicePath(),
  name: 'Hromadná pošta',
  title: 'Hromadné rozesílání pošty',
  children: [
    {
      path: postServiceSentPath(),
      name: 'Přehled',
      title: 'Přehled hromadné pošty',
    },
    {
      path: postServiceCreatePath(),
      name: 'Rozeslat novou',
      title: 'Rozeslat novou hromadnou poštu',
    },
    {
      path: postServiceTemplatesPath(),
      name: 'Šablony',
      title: 'Hromadná pošta - šablony dopisů',
    },
    {
      path: postServiceRecipientListPath(),
      name: 'Adresáti',
      title: 'Adresáti hromadné pošty',
      children: [
        {
          path: postServiceSentListPath(':id'),
          name: 'Adresovaná pošta',
          title: 'Přehled adresátů hromadné pošty',
          disabled: true,
          children: [
            {
              path: postServiceSentListPath(':id'),
              name: 'Přehled',
              title: 'Přehled adresátů hromadné pošty',
            },
          ],
        },
      ],
    },
    {
      path: postServiceLetterPath(),
      name: 'Tvorba dopisu',
      title: 'Tvorba dopisu',
      disabled: true,
      children: [
        {
          path: postServiceLetterPath(undefined, ':templateId'),
          name: 'Editace',
          title: 'Tvorba dopisu se šablonou',
          disabled: true,
        },
        {
          path: postServiceLetterPath(':recipientListId', ':templateId'),
          name: 'Nový',
          title: 'Tvorba dopisu se šablonou',
          disabled: true,
        },
      ],
    },
  ],
}

const watchdog: BreadcrumbConfig = {
  path: watchdogPath(),
  name: 'Hlídač katastru',
  title: 'Hlídač katastru',
  menu: watchdogDropdown,
  children: [
    {
      path: watchdogPropertyPath(),
      name: 'Nemovitosti',
      title: 'Hlídač katastru - přehled nemovitostí',
      children: [
        {
          path: watchdogPropertyPath(':channelId'),
          name: 'Detail',
          title: 'Hlídač katastru - Detail kanálu',
        },
      ],
    },
    {
      path: watchdogChannelPath(),
      name: 'Kanály',
      title: 'Hlídač katastru - Kanály',
    },
  ],
}

const auction: BreadcrumbConfig = {
  path: auctionMonitoringPath(),
  name: 'Dražby',
  title: 'Monitoring dražeb',
  tabLabels: MONITORING_TABS,
  menu: auctionDropdown,
}

const foreclosure: BreadcrumbConfig = {
  path: foreclosureMonitoringPath(),
  name: 'Exekuce',
  title: 'Monitoring exekucí',
  tabLabels: MONITORING_TABS,
  menu: foreclosureDropdown,
}

const insolvency: BreadcrumbConfig = {
  path: insolvencyMonitoringPath(),
  name: 'Insolvence',
  title: 'Monitoring insolvencí',
  tabLabels: MONITORING_TABS,
  menu: insolvencyDropdown,
}

const heritage: BreadcrumbConfig = {
  path: heritageMonitoringPath(),
  name: 'Dědická řízení',
  title: 'Monitoring dědictví - přehled řízení',
  tabLabels: MONITORING_TABS,
}

const wsdp: BreadcrumbConfig = {
  path: cuzkWsdpPath(),
  name: 'Dálkový přístup KN',
  title: 'Dálkový přístup KN',
  menu: wsdpDropdown,
  children: [
    {
      path: cuzkEpoPath(),
      name: 'Evidence práv pro osobu',
      title: 'Evidence práv pro osobu',
      children: [
        {
          path: cuzkEpoDetailPath(':id'),
          name: 'Přehled',
          title: 'EPO - Detail subjektu',
          tabLabels: COLLECTION_TABS,
        },
      ],
    },
    {
      path: cuzkLvPath(),
      name: 'Listy vlastnictví',
      title: 'Listy vlastnictví',
      children: [
        {
          path: cuzkLvDetailPath(':id'),
          name: 'Detail',
          title: 'Detail listu vlastnictví',
          tabLabels: COLLECTION_TABS,
        },
      ],
    },
    {
      path: cuzkMonitorRcPath(),
      name: 'Subjekty v ČÚZK',
      title: 'Hlídač subjektů ČÚZK',
      children: [
        {
          path: cuzkMonitorRcCreatePath(),
          name: 'Přidat nový',
          title: 'Vyhledat subjekt v ČÚZK',
          tabLabels: LUSTRATION_TABS,
        },
      ],
    },
    {
      path: cuzkDocumentCollectionPath(),
      name: 'Sbírka listin',
      title: 'Sbírka listin ČÚZK',
    },
  ],
}

const statistics: BreadcrumbConfig = {
  path: statisticsPath(),
  name: 'Statistiky využití',
  title: 'Statistiky využití',
}

export const breadcrumbConfig: BreadcrumbConfig[] = [
  property,
  dashboard,
  overview,
  search,
  cadastreMap,
  buyback,
  propertyList,
  priceEstimate,
  marketplace,
  cee,
  postService,
  {
    path: monitoringPath(),
    name: 'Monitoring',
    title: 'Monitoring',
    children: [foreclosure, insolvency, heritage, auction, watchdog],
    menu: monitoringDropdown,
  },
  wsdp,
  statistics,
]
